import { Line } from 'vue-chartjs'
import { ChartConfig } from '../constants/chart-config'

const lineTension = 0.1
const borderWidth = 1
const pointRadius = 5
const pointBorderWidth = 2

export default {
  extends: Line,
  props: {
    dataLists: {
      items: Array // 그릴 데이터 목록
    },
    items: undefined,
    max: 0,
    labels: {
      type: Array
    }
  },
  data () {
    return {
      dataSets: [],
      gradient1: null,
      gradient2: null,
      options: {
        scales: {
          yAxes: [],
          xAxes: [{
            gridLines: {
              display: true,
              drawBorder: false
            },
            ticks: {
              padding: 10
            }
          }]
        },
        tooltip: {
          enabled: true
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  watch: {
    dataLists: {
      deep: true,
      handler () {
        if (this.dataLists.items.length > 0) {
          this.generateDataSets(this.dataLists)
          this.generateYaxes(this.dataLists.max)
        }
        this.renderChart({labels: this.labels, datasets: this.dataSets}, this.options)
      }
    },
    max: function (newVal, oldVal) {
      this.dataSets = []
      this.generateYaxes(newVal)
      this.items.forEach((data, index) => {
        this.dataSets.push(
          {
            label: data.name,
            lineTension,
            borderColor: ChartConfig.chartColors[index % 20],
            pointBorderColor: ChartConfig.chartColors[index % 20],
            pointBorderWidth,
            pointRadius,
            fill: false,
            pointBackgroundColor: ChartConfig.chartColors[index % 20],
            borderWidth,
            data: data.data
          }
        )
      })
      this.renderChart({labels: this.labels, datasets: this.dataSets}, this.options)
    }
  },
  mounted () {
    this.generateDataSets(this.dataLists)
    this.generateYaxes(this.dataLists.max)
    this.renderChart({labels: this.labels, datasets: this.dataSets}, this.options)
  },
  methods: {
    generateYaxes (val) {
      this.options.scales.yAxes = []
      var max = val
      var step = Math.floor(Math.floor(Math.floor(max) / 5))
      if (step < 10) {
        step = max
      } else if (step < 100) {
        step = Math.floor(Math.floor(Math.floor(max) / 5) / 10) * 10
      } else {
        step = Math.floor(Math.floor(Math.floor(max) / 5) / 100) * 100
      }
      max = max ? Math.ceil(max / step) * step : 10
      this.options.scales.yAxes.push({
        gridLines: {
          display: true,
          drawBorder: false
        },
        ticks: {
          stepSize: step,
          min: 0,
          max: max
        }
      })
    },
    generateDataSets (val) {
      if (!this.dataLists.items) {
        return false
      }
      this.dataSets = []
      if (this.enableShadow !== false) {
        let ctx = this.$refs.canvas.getContext('2d')
        let _stroke = ctx.stroke
        ctx.stroke = function () {
          ctx.save()
          ctx.shadowColor = ChartConfig.shadowColor
          ctx.shadowBlur = 10
          ctx.shadowOffsetX = 0
          ctx.shadowOffsetY = 12
          _stroke.apply(this, arguments)
          ctx.restore()
        }
      }
      val.items.forEach((data, index) => {
        this.dataSets.push(
          {
            label: data.name,
            lineTension,
            borderColor: ChartConfig.chartColors[index % 20],
            pointBorderColor: ChartConfig.chartColors[index % 20],
            pointBorderWidth,
            pointRadius,
            fill: false,
            pointBackgroundColor: ChartConfig.chartColors[index % 20],
            borderWidth,
            data: data.data
          }
        )
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/charts/CustomLineChart.js